'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoUsb = function IoUsb(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm11.3 17.2z m18.7-7.2c0 0.9-0.5 1.6-1.1 2.1-0.1 0.1-0.2 0.4-0.2 0.6-0.1 1.5-0.3 2.8-0.7 3.9-0.6 1.4-1.6 2.5-3.1 3.6-1.3 0.9-2.2 1.6-2.8 2.6-0.5 0.9-0.9 2.2-0.9 4.2v1.8c0 0.6 0.2 1 0.8 1.4 0.3 0.2 0.6 0.5 0.8 0.7 0.6 0.7 1.1 1.7 1.1 2.7 0 2.2-1.7 3.9-3.9 3.9s-3.9-1.7-3.9-3.9v-0.1c0-1.4 0.8-2.6 1.9-3.3 0.4-0.3 0.7-0.4 0.7-1.4 0-1.1-0.3-1.3-0.8-2.1s-1.4-1.3-2.5-2c-1.5-1-2.6-2.1-3.1-3.6-0.5-1.2-0.7-2.4-0.7-3.1s-0.2-0.7-0.4-0.8c-0.7-0.5-1.2-1.3-1.2-2.2 0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5c0 0.8-0.3 1.6-0.9 2-0.3 0.2-0.4 0.9-0.4 1.1 0 0.7 0.3 1.4 0.6 2.2 0.8 1.7 3.5 3.5 4.1 3.5s0.6-0.4 0.6-1v-15.3s-0.1-0.2-0.3-0.3h0v-0.1c-0.7-0.5-1.2-1.2-1.2-2.1 0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5c0 0.9-0.4 1.6-1.1 2.1-0.1 0.2-0.1 0.2-0.1 0.4v10.9c0 0.8 0.1 1 0.6 0.9 1-0.2 3.7-2.3 4-3.4 0.3-0.7 0.5-1.8 0.6-3.2v0c0-0.2-0.2-0.4-0.2-0.5-0.8-0.5-1.3-1.3-1.3-2.2 0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5z m-17.5 6.3c0.7 0 1.3-0.6 1.3-1.3s-0.6-1.2-1.3-1.2-1.2 0.5-1.2 1.2 0.5 1.3 1.2 1.3z m7.5-10c0.7 0 1.3-0.6 1.3-1.3s-0.6-1.2-1.3-1.2-1.2 0.5-1.2 1.2 0.5 1.3 1.2 1.3z m7.5 5c0.7 0 1.3-0.6 1.3-1.3s-0.6-1.2-1.3-1.2-1.2 0.5-1.2 1.2 0.5 1.3 1.2 1.3z' })
        )
    );
};

exports.default = IoUsb;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/usb.js
// module id = 3002
// module chunks = 168707334958949